import {useNavigate} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {useEffect, useRef, useState} from 'react';
import { SimpleSearch } from '../../../../../reduxToolkit/Search/SearchApi';
import { TABLES } from '../../../../../Apis/Tables';
import {SEARCH_MODEL} from '../../../../../components/table/Model/TableModel';
import {getViewTypeByName} from '../../../../../enums/ViewType';
import TableFunction from "../../../../../components/table/TableFunction";
import {permissionObj} from "../../../../../Helpers/permission";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack
 * @Email : kpozos@ibl.mx
 *
 */
const IngredientsCardsApp = ({
     view,
     setBodyForExport,
     modified,
     setModified,
     selectedList,
     setSelectedList,
     setIsAllChecked,
     option
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [searchElement, setSearchElement] = useState('');
    const [searchResults, setSearchResults] = useState('');
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const elementRef = useRef(null);
    const viewType = getViewTypeByName(view);
    const deletePermission =    DEV || permission?.includes(permissionObj?.WEB_INGREDIENT_DELETE);

    // On layout change, update a CSS variable with the element's top position
    useEffect(() => {
        if (elementRef?.current) {
            const rect = elementRef.current.getBoundingClientRect();
            elementRef.current.style.setProperty('--top-value', `${rect.top}px`);
        }
    }, [searchResults]);

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({
            page: page,
            size: rowsPerPage,
            model: option,
            key: searchElement,
            viewType: viewType
        });
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(({ payload: { data: { data, success } } }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            }
        );
    }

    const {
        t,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage
    } = TableFunction({
        selectedList,
        setSelectedList,
        data:searchResults,
        view,
        labelRowsPerPage: 'ingredient_per_page',
        setIsAllChecked,
        fixedPagination: false, // Disable fixed pagination
        hasContainer: true, // Enable container for the table
        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });


    return {
        t,
        DEV,
        navigate,
        rowsPerPage,
        searchResults,
        setSearchResults,
        permission,
        elementRef,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        setSimpleSearch,
        handleDeleteAll,
        handleCheckboxChange,
        pagination,
        deletePermission
    }

}

export default IngredientsCardsApp;
